
import React from 'react';
import { Link } from 'react-router-dom';

const BusinessAdvantages: React.FC = () => {
  return (
    <>
      <h2 className="text-2xl font-bold mb-4 mt-8 text-itmgmt-dark-blue">The Business Case for Zero-Trust</h2>
      
      <p className="mb-4 text-gray-700 leading-relaxed">
        Beyond security benefits, zero-trust offers compelling business advantages:
      </p>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
        <div className="bg-white p-5 rounded-lg border-l-4 border-itmgmt-medium-blue shadow-sm">
          <h4 className="font-bold text-itmgmt-dark-blue mb-2">Competitive Advantage</h4>
          <p className="text-gray-700 text-sm">
            Increasingly, clients and partners require evidence of robust security practices before engaging in business relationships.
          </p>
        </div>
        <div className="bg-white p-5 rounded-lg border-l-4 border-itmgmt-medium-blue shadow-sm">
          <h4 className="font-bold text-itmgmt-dark-blue mb-2">Regulatory Compliance</h4>
          <p className="text-gray-700 text-sm">
            Zero-trust architectures help satisfy requirements for GDPR, HIPAA, PCI-DSS, and other regulations. Learn more in our 
            <Link to="/blog/hipaa-compliance-it-requirements-healthcare" className="text-itmgmt-medium-blue"> HIPAA compliance guide</Link>.
          </p>
        </div>
        <div className="bg-white p-5 rounded-lg border-l-4 border-itmgmt-medium-blue shadow-sm">
          <h4 className="font-bold text-itmgmt-dark-blue mb-2">Operational Resilience</h4>
          <p className="text-gray-700 text-sm">
            By compartmentalizing systems and access, zero-trust limits the impact of any successful breach.
          </p>
        </div>
        <div className="bg-white p-5 rounded-lg border-l-4 border-itmgmt-medium-blue shadow-sm">
          <h4 className="font-bold text-itmgmt-dark-blue mb-2">Remote Work Enablement</h4>
          <p className="text-gray-700 text-sm">
            Zero-trust is inherently designed for today's distributed workforce, allowing secure access from anywhere.
          </p>
        </div>
      </div>
    </>
  );
};

export default BusinessAdvantages;
